import { render } from "./UploadingBox.vue?vue&type=template&id=289bdf68&scoped=true"
import script from "./UploadingBox.vue?vue&type=script&lang=js"
export * from "./UploadingBox.vue?vue&type=script&lang=js"

import "./UploadingBox.vue?vue&type=style&index=0&id=289bdf68&scoped=true&lang=css"

import exportComponent from "/Users/georgeconstantine/Documents/import/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289bdf68"]])

export default __exports__